import { render, staticRenderFns } from "./TaxModal.vue?vue&type=template&id=52181b47&"
import script from "./TaxModal.vue?vue&type=script&lang=js&"
export * from "./TaxModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports